import React, { Component } from "react";
import {
  Container,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TableContainer,
} from "@material-ui/core";
import BreadCrumbOwn from "../Essentials/BreadCrumbOwn";
import { GetData } from "../../api/service";
import moment from "moment";
class ResearchProjectDbt extends Component {
  state = {
    data: [],
    isLoaded: false,
  };

  __loadFile = () => {
    GetData(`/getdbtresearchprojects`).then((resp) => {
      this.setState({
        data: Array.isArray(resp) ? resp : [],
        isLoaded: true,
      });
    });
  };

  componentDidMount() {
    this.__loadFile();
  }

  render() {
    return (
      <div>
        <BreadCrumbOwn title="DBT funded Research Projects" />
        <Container className="mb-5" style={{ minHeight: "70vh" }}>
          <Typography
            variant="h5"
            style={{ marginTop: "1em", marginBottom: "1em", fontWeight: 700 }}
          >
            Assets
          </Typography>

          {this.state.isLoaded ? (
            this.state.data.length > 0 ? (
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow style={{ backgroundColor: "#1E3760" }}>
                      <TableCell style={{ color: "white", fontWeight: 700 }}>
                        #
                      </TableCell>
                      <TableCell style={{ color: "white", fontWeight: 700 }}>
                        Name of the Equipment / Asset
                      </TableCell>
                      <TableCell style={{ color: "white", fontWeight: 700 }}>
                        Sanctioned Cost
                      </TableCell>
                      <TableCell style={{ color: "white", fontWeight: 700 }}>
                        Actual Cost
                      </TableCell>
                      <TableCell style={{ color: "white", fontWeight: 700 }}>
                        Quantity Procured
                      </TableCell>
                      <TableCell style={{ color: "white", fontWeight: 700 }}>
                        Date of Purchase
                      </TableCell>
                      <TableCell style={{ color: "white", fontWeight: 700 }}>
                        Photo
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.data.map((el, index) => (
                      <TableRow key={el.id}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{el.equipment_name}</TableCell>
                        <TableCell>{el.sanctioned_cost}</TableCell>
                        <TableCell>{el.actual_cost}</TableCell>
                        <TableCell>{el.quantity_procured}</TableCell>
                        <TableCell>{moment(el.date_of_purchase, "YYYY-MM-DD").format("DD-MM-YYYY")}</TableCell>
                        <TableCell>
                          {Array.isArray(el.upload_info) &&
                          el.upload_info.length > 0 ? (
                            <a
                              href={el.upload_info[0].url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                src={el.upload_info[0].url}
                                alt={el.equipment_name}
                                style={{
                                  width: 100,
                                  height: 80,
                                  objectFit: "cover",
                                  border: "1px solid #ddd",
                                }}
                              />
                            </a>
                          ) : (
                            "-"
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Typography>No assets found.</Typography>
            )
          ) : (
            <Typography>Loading . . . </Typography>
          )}
          <br />
          <br />
        </Container>
      </div>
    );
  }
}

export default ResearchProjectDbt;
